import { ElLoading } from 'element-plus';
import { useLoadingStore } from '../store/LoadingStore';
import { ref } from 'vue';
import CONSTANTS from '../global/constants'


let loadingFrame = null;
let loadingLock = false;
let loadingClosed = true;

const LOADING_TEXT_MAP = new Map([
    [1, CONSTANTS.LOADING_TEXT_LOADDATA], 
    [2, CONSTANTS.LOADING_TEXT_DELETEDATA],
    [3, CONSTANTS.LOADING_TEXT_SAVEDATA],
]);
let loadingText = ref('数据加载中，请稍等...');


const show = (state) => {
    if (!state) state = 0;
    loadingText.value = LOADING_TEXT_MAP.get(state);
    loadingClosed = false;
    if (loadingFrame) return;
    loadingFrame = ElLoading.service({
        lock: true,
        text: loadingText.value || '',
        background: 'rgba(255, 255, 255, 0.7)',
    })
    loadingLock = true;
    setTimeout(function() {
        loadingLock = false;
        if (loadingClosed) {
            hide();
        }
    }, 300)
}
const hide = () => {
    loadingClosed = true;
    if (loadingLock || !loadingFrame) return;
    loadingFrame.close();
    loadingFrame = null;
}

export function watchLoading() {
    const loadingStore = useLoadingStore();
    loadingStore.$subscribe((mutation, state) => {
        if (state.loading > 0) show(state.state);
        else hide();
    })
}
export function showLoading(state) {
    const loadingStore = useLoadingStore();
    loadingStore.startLoading(state);
}
export function hideLoading() {
    const loadingStore = useLoadingStore();
    loadingStore.endLoading();
}
